import React, { useMemo, useContext, useState, useEffect, useRef } from 'react';
import { s as styles, r as resizeMediaUrl, e as expand } from './expand.js';
import classnames from 'classnames';
import { g as getFixedStyles, G as GALLERY_TYPE } from './viewer-loadable2.js';
import { normalizeHref, uuid } from 'wix-rich-content-common';
import { GalleryOptions_Layout_Type } from 'ricos-schema';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { GALLERY_CONSTS, ProGallery } from 'pro-gallery';
import { debounce } from 'lodash';
import 'image-client-api/dist/imageClientSDK';
import '@loadable/component';
import 'ricos-types';

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$3) {
    for (var _iterator = _createForOfIteratorHelperLoose$3(__getOwnPropSymbols$3(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$3.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
function convertToGalleryItems(items, relValue, anchorTarget) {
  return items.map(function (item, index) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var image = item.image,
      video = item.video,
      title = item.title,
      altText = item.altText;
    var mediaUrl = ((_b = (_a = image == null ? void 0 : image.media) == null ? void 0 : _a.src) == null ? void 0 : _b.url) || ((_d = (_c = video == null ? void 0 : video.media) == null ? void 0 : _c.src) == null ? void 0 : _d.url) || "";
    var width = ((_e = image == null ? void 0 : image.media) == null ? void 0 : _e.width) || ((_f = video == null ? void 0 : video.media) == null ? void 0 : _f.width) || 0;
    var height = ((_g = image == null ? void 0 : image.media) == null ? void 0 : _g.height) || ((_h = video == null ? void 0 : video.media) == null ? void 0 : _h.height) || 0;
    var convertedData = {
      mediaUrl: mediaUrl,
      url: mediaUrl,
      metaData: {
        type: image ? "image" : "video",
        height: height,
        width: width,
        title: title,
        alt: altText
      }
    };
    if (video) {
      convertedData.metaData.link = {
        target: "_blank",
        rel: "noopener",
        url: normalizeHref(mediaUrl || "")
      };
      var _ref = video.thumbnail || {},
        src = _ref.src,
        thumbnailWidth = _ref.width,
        thumbnailHeight = _ref.height;
      if (src == null ? void 0 : src.url) {
        convertedData.metaData.poster = {
          url: src.url,
          width: thumbnailWidth || width,
          height: thumbnailHeight || height
        };
      }
    }
    if (image == null ? void 0 : image.link) {
      var _image$link = image.link,
        linkUrl = _image$link.url,
        linkTarget = _image$link.target,
        linkRel = _image$link.rel;
      var target = linkTarget && "_" + linkTarget.toLowerCase() || anchorTarget || "_self";
      var url = normalizeHref(linkUrl || "");
      var rel = relValue || "noopener";
      if (linkRel) {
        rel = "noopener";
        linkRel.nofollow && (rel += " nofollow");
        linkRel.sponsored && (rel += " sponsored");
        linkRel.ugc && (rel += " ugc");
        (linkRel.noreferrer || linkRel.noreferrer === void 0) && (rel += " noreferrer");
      }
      convertedData.metaData.link = {
        type: "wix",
        target: target,
        data: {
          type: "ExternalLink",
          target: target,
          rel: rel,
          url: url
        }
      };
      convertedData.directLink = {
        url: url,
        target: target,
        rel: rel
      };
    }
    return __spreadProps$1(__spreadValues$2({}, convertedData), {
      // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - breaks the video controls behavoiur.
      itemId: uuid() + "_" + index.toString(),
      hash: mediaUrl + "_" + index.toString()
    });
  });
}
function useItems(items, relValue, anchorTarget) {
  var galleryItems = useMemo(function () {
    return convertToGalleryItems(items, relValue, anchorTarget);
  }, [items]);
  return galleryItems;
}

var _GALLERY_LAYOUT_TO_NU, _NUMBER_TO_GALLERY_LA;
var isHorizontalLayout = function isHorizontalLayout(_ref) {
  var layout = _ref.layout;
  return layout && ([GalleryOptions_Layout_Type.THUMBNAIL, GalleryOptions_Layout_Type.SLIDER, GalleryOptions_Layout_Type.SLIDESHOW, GalleryOptions_Layout_Type.COLUMN, GalleryOptions_Layout_Type.FULLSIZE].includes(layout.type) || layout.horizontalScroll);
};
var sampleItems = [1, 2, 3].map(function (i) {
  return {
    metaData: {
      height: 10,
      width: 10
    },
    itemId: "sampleItem-" + i,
    mediaUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAAA1JREFUCB1jePv27X8ACVkDxyMHIvwAAAAASUVORK5CYII="
    //eslint-disable-line
  };
});

var GALLERY_LAYOUT_TO_NUMBER = (_GALLERY_LAYOUT_TO_NU = {}, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.GRID] = GALLERY_CONSTS.layout.GRID, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.MASONRY] = GALLERY_CONSTS.layout.MASONRY, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.COLLAGE] = GALLERY_CONSTS.layout.COLLAGE, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.THUMBNAIL] = GALLERY_CONSTS.layout.THUMBNAIL, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.SLIDER] = GALLERY_CONSTS.layout.SLIDER, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.SLIDESHOW] = GALLERY_CONSTS.layout.SLIDESHOW, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.PANORAMA] = GALLERY_CONSTS.layout.PANORAMA, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.COLUMN] = GALLERY_CONSTS.layout.COLUMN, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.MAGIC] = GALLERY_CONSTS.layout.MAGIC, _GALLERY_LAYOUT_TO_NU[GalleryOptions_Layout_Type.FULLSIZE] = GALLERY_CONSTS.layout.FULLSIZE, _GALLERY_LAYOUT_TO_NU);
(_NUMBER_TO_GALLERY_LA = {}, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.COLLAGE] = GalleryOptions_Layout_Type.COLLAGE, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.MASONRY] = GalleryOptions_Layout_Type.MASONRY, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.GRID] = GalleryOptions_Layout_Type.GRID, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.THUMBNAIL] = GalleryOptions_Layout_Type.THUMBNAIL, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.SLIDER] = GalleryOptions_Layout_Type.SLIDER, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.SLIDESHOW] = GalleryOptions_Layout_Type.SLIDESHOW, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.PANORAMA] = GalleryOptions_Layout_Type.PANORAMA, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.COLUMN] = GalleryOptions_Layout_Type.COLUMN, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.MAGIC] = GalleryOptions_Layout_Type.MAGIC, _NUMBER_TO_GALLERY_LA[GALLERY_CONSTS.layout.FULLSIZE] = GalleryOptions_Layout_Type.FULLSIZE, _NUMBER_TO_GALLERY_LA);

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
GALLERY_CONSTS.scrollDirection.HORIZONTAL;
var convertToGalleryOptions = function convertToGalleryOptions(options) {
  var galleryOptions = {};
  var layout = options.layout,
    thumbnails = options.thumbnails,
    item = options.item;
  if (layout) {
    var type = layout.type,
      horizontalScroll = layout.horizontalScroll,
      orientation = layout.orientation,
      numberOfColumns = layout.numberOfColumns,
      mobileNumberOfColumns = layout.mobileNumberOfColumns;
    type && (galleryOptions.galleryLayout = parseInt(GALLERY_LAYOUT_TO_NUMBER[type]));
    horizontalScroll && (galleryOptions.scrollDirection = GALLERY_CONSTS.scrollDirection.HORIZONTAL);
    orientation && (galleryOptions.isVertical = orientation === "COLUMNS");
    typeof numberOfColumns === "number" && (galleryOptions.numberOfImagesPerRow = numberOfColumns);
    typeof mobileNumberOfColumns === "number" && (galleryOptions.m_numberOfImagesPerRow = mobileNumberOfColumns);
  }
  if (item) {
    var targetSize = item.targetSize,
      ratio = item.ratio,
      crop = item.crop,
      spacing = item.spacing;
    typeof targetSize === "number" && (galleryOptions.gallerySizePx = targetSize);
    typeof ratio === "number" && (galleryOptions.cubeRatio = ratio);
    crop && (galleryOptions.cubeType = crop.toLowerCase());
    typeof spacing === "number" && (galleryOptions.imageMargin = spacing);
  }
  if (thumbnails) {
    var placement = thumbnails.placement,
      _spacing = thumbnails.spacing;
    placement && (galleryOptions.galleryThumbnailsAlignment = placement.toLowerCase());
    typeof _spacing === "number" && (galleryOptions.thumbnailSpacings = _spacing / 2);
  }
  return galleryOptions;
};
function useOptions(options, disableDownload) {
  var _useContext = useContext(RicosContext),
    isMobile = _useContext.isMobile;
  var galleryOptions = useMemo(function () {
    var _a;
    var isHorizontal = isHorizontalLayout(options);
    var calculatedOptions = __spreadValues$1(__spreadProps(__spreadValues$1({}, getFixedStyles(((_a = options.layout) == null ? void 0 : _a.type) || GalleryOptions_Layout_Type.GRID)), {
      allowContextMenu: !disableDownload,
      showArrows: isHorizontal
    }), convertToGalleryOptions(options));
    if (isMobile) {
      if (calculatedOptions.m_numberOfImagesPerRow) {
        calculatedOptions.numberOfImagesPerRow = calculatedOptions.m_numberOfImagesPerRow;
      }
      if (isHorizontal) {
        calculatedOptions.arrowsSize = 20;
        !calculatedOptions.imageMargin && (calculatedOptions.imageMargin = 0);
        if (calculatedOptions.galleryLayout === GalleryOptions_Layout_Type.THUMBNAIL) {
          calculatedOptions.thumbnailSize = 90;
        }
      }
    }
    return calculatedOptions;
  }, [options]);
  return galleryOptions;
}

var shouldConsiderThumbnailSize = function shouldConsiderThumbnailSize(layout, options, isMobile) {
  var galleryThumbnailsAlignment = options.galleryThumbnailsAlignment;
  return isMobile && layout === GalleryOptions_Layout_Type.THUMBNAIL && ["top", "bottom"].includes(galleryThumbnailsAlignment || "");
};
var getGalleryHeight = function getGalleryHeight(layout, options, isMobile, width) {
  var height = 305;
  if (width) {
    height = shouldConsiderThumbnailSize(layout, options, isMobile) ? Math.floor(width * 2 / 3) + 95 : Math.floor(width * 3 / 4);
  }
  return height;
};
var getDimensions = function getDimensions(galleryRef, layout, options, isMobile) {
  var _a;
  var width = Math.floor(((_a = galleryRef == null ? void 0 : galleryRef.current) == null ? void 0 : _a.getBoundingClientRect().width) || 0);
  var height = getGalleryHeight(layout, options, isMobile, width);
  return {
    width: width,
    height: height
  };
};
function useDimensions(galleryRef, options, layout, scrollingElement) {
  var _useContext = useContext(RicosContext),
    isMobile = _useContext.isMobile;
  var _useState = useState(getDimensions(galleryRef, layout, options, isMobile)),
    size = _useState[0],
    setSize = _useState[1];
  var _useState2 = useState(0),
    clientHeight = _useState2[0],
    setClientHeight = _useState2[1];
  var updateDimensions = debounce(function () {
    setSize(getDimensions(galleryRef, layout, options, isMobile));
  }, 70);
  useEffect(function () {
    var contentElement = typeof scrollingElement === "function" ? scrollingElement() : scrollingElement || document.body;
    if ((contentElement == null ? void 0 : contentElement.nodeType) !== 1) {
      contentElement = document.body;
    }
    var observer = new MutationObserver(function () {
      if (contentElement.clientHeight !== clientHeight) {
        setClientHeight(contentElement.clientHeight);
        updateDimensions();
      }
    });
    observer.observe(contentElement, {
      attributes: true,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  }, []);
  useEffect(function () {
    var handleResize = function handleResize() {
      updateDimensions();
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, [galleryRef]);
  useEffect(function () {
    setSize(getDimensions(galleryRef, layout, options, isMobile));
  }, [galleryRef, layout]);
  return size;
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __objRest$1 = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var GALLERY_EVENTS = GALLERY_CONSTS.events;
var GalleryViewer = function GalleryViewer(_ref) {
  var componentData = _ref.componentData,
    nodeId = _ref.nodeId,
    settings = _ref.settings,
    relValue = _ref.relValue,
    anchorTarget = _ref.anchorTarget,
    seoMode = _ref.seoMode,
    helpers = _ref.helpers,
    itemOverlayElement = _ref.itemOverlayElement;
  var _a = settings,
    scrollingElement = _a.scrollingElement,
    gallerySettings = __objRest$1(_a, ["scrollingElement"]);
  var galleryRef = useRef(null);
  var _ref2 = componentData || {},
    ricosItems = _ref2.items,
    ricosOptions = _ref2.options,
    disableExpand = _ref2.disableExpand,
    disableDownload = _ref2.disableDownload;
  var items = useItems(ricosItems || [], relValue, anchorTarget);
  var options = useOptions(ricosOptions || {}, disableDownload);
  var size = useDimensions(galleryRef, options, ricosOptions == null ? void 0 : ricosOptions.layout.type, scrollingElement);
  var handleContextMenu = function handleContextMenu(e) {
    return disableDownload && e.preventDefault();
  };
  var viewMode = seoMode ? GALLERY_CONSTS.viewMode.SEO : GALLERY_CONSTS.viewMode.SITE;
  var hasExpand = !disableExpand && !settings.disableExpand && settings.onExpand && ricosItems.length > 0;
  var handleExpand = function handleExpand(data) {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, GALLERY_TYPE, "Click", "expand_gallery");
    hasExpand && settings.onExpand(nodeId, data.idx);
  };
  var handleGalleryEvents = function handleGalleryEvents(name, data) {
    switch (name) {
      case GALLERY_EVENTS.GALLERY_CHANGE:
        if (galleryRef.current) {
          if (!isHorizontalLayout(options)) {
            galleryRef.current.style.height = data.layoutHeight + "px";
          } else {
            galleryRef.current.style.height = "auto";
          }
        }
        break;
      case GALLERY_EVENTS.ITEM_ACTION_TRIGGERED:
        data.type !== "video" && !data.linkData.url && !disableExpand && handleExpand(data);
        break;
    }
  };
  var renderExpandIcon = function renderExpandIcon(itemProps) {
    return /* @__PURE__ */React.createElement("div", {
      className: styles.expandContainer
    }, /* @__PURE__ */React.createElement(expand, {
      className: styles.expandIcon,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        handleExpand(itemProps);
      }
    }));
  };
  var renderTitle = function renderTitle(title) {
    return title ? /* @__PURE__ */React.createElement("div", {
      className: styles.imageTitleContainer
    }, /* @__PURE__ */React.createElement("div", {
      className: styles.imageTitle
    }, title)) : null;
  };
  var customHoverRenderer = function customHoverRenderer(itemProps) {
    var isClickable = hasExpand || itemProps.link;
    var itemOverlayStyles = classnames(styles.itemOverlay, isClickable && styles.clickableItem);
    return /* @__PURE__ */React.createElement("div", {
      className: itemOverlayStyles
    }, hasExpand && renderExpandIcon(itemProps), renderTitle(itemProps.title), itemOverlayElement == null ? void 0 : itemOverlayElement(itemProps));
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: galleryRef,
    className: styles.gallery_container,
    "data-hook": "galleryViewer",
    role: "none",
    onContextMenu: handleContextMenu
  }, (size == null ? void 0 : size.width) ? /* @__PURE__ */React.createElement(ProGallery, {
    domId: nodeId,
    id: nodeId,
    items: items.length > 0 ? items : sampleItems,
    options: options,
    container: size,
    settings: gallerySettings,
    scrollingElement: typeof scrollingElement === "function" ? scrollingElement() : scrollingElement,
    eventsListener: handleGalleryEvents,
    createMediaUrl: resizeMediaUrl,
    viewMode: viewMode,
    customComponents: {
      customHoverRenderer: customHoverRenderer
    },
    totalItemsCount: items.length || sampleItems.length
  }) : null);
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var Gallery = function Gallery(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    relValue = _useContext.relValue,
    anchorTarget = _useContext.anchorTarget,
    config = _useContext.config,
    seoMode = _useContext.seoMode,
    helpers = _useContext.helpers;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(GalleryViewer, {
    componentData: node.galleryData || {},
    nodeId: node.id,
    settings: config[GALLERY_TYPE],
    relValue: relValue,
    anchorTarget: anchorTarget,
    seoMode: seoMode,
    helpers: helpers
  }));
};
var GalleryRenderer = function GalleryRenderer(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  return /* @__PURE__ */React.createElement(Gallery, __spreadValues({
    key: node.id,
    node: node
  }, props));
};

export { GalleryRenderer as default };

import 'wix-rich-content-plugin-gallery/dist/loadable/viewer/es/styles.viewer.min.global.css'